import InfoPanel from '@/components/common/InfoPanel/InfoPanel'
import InfoItem from '@/components/common/InfoItem/InfoItem'
import TaxInformation from '@/containers/Store/PaymentAndTaxView/sections/TaxInformation'

export default function PaymentInformation({storeData}) {
  const salesInfo = storeData?.salesInformation || {};
  
  return (
    <InfoPanel title="Payment" isCollapsible={false} defaultOpen={true} className="mt-4 ">
      <div className="px-4">
        <div className="grid grid-cols-3 gap-y-6">
          <InfoItem label="Payment Method Code" value={storeData?.payment?.paymentMethodCode ?? '-'} />
          <InfoItem label="Currency" value={storeData?.payment?.currency ?? '-'} />
          <InfoItem label="Credit Block" value={storeData?.payment?.creditBlock ?? '-'} />

          <InfoItem label="Credit Limit Amount" value={storeData?.payment?.creditLimitAmount ?? '-'} />
          <InfoItem label="Payment Term Code" value={storeData?.payment?.paymentTermCode ?? '-'} />
          <InfoItem label="Price Group" value={storeData?.payment?.priceGroup ?? '-'} />

          <InfoItem label="Price List" value={storeData?.payment?.priceList ?? '-'} />
        </div>
      </div>
      <TaxInformation storeData={storeData} />
    </InfoPanel>
  )
}
